import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { getters } from './getters'
import { state } from './state'

export const registerStore = (gaApp: GaApp) => {
  const init = defineStore('modalRegister', {
    state,
    getters: getters(gaApp),
  })

  return init(getActivePinia())
}
